import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { getDefaultPartner } from '~/features/admin/components/partner/utils'
import usePartnerConfigQueries from '~/features/partners/hooks/usePartnerConfigQueries'

const usePartnerCentralized = () => {
  const location = useLocation()
  const { isLoading, partner } = usePartnerConfigQueries({ shouldFetch: false })

  return useMemo(
    () => ({
      isLoading,
      partner: getDefaultPartner(partner),
      location,
    }),
    [isLoading, partner, location],
  )
}

export default usePartnerCentralized
